// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-440a33f2]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.box[data-v-440a33f2]{padding:20px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
